import React from "react";
import {
  Box,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IPriceItinerary } from "../interfaces.lowPrice";
import {
  dateObjToDayDateStringShort,
  dateObjToMonthShortDate,
  dateObjToWeekday,
  useConfig,
} from "@thekilroygroup/shared-ui";

interface IProps {
  priceItinerary: IPriceItinerary;
  height: number;
  width: number;
  sxProps?: SxProps;
}

export const ReturnDate = (props: IProps) => {
  const { priceItinerary, height, width, sxProps } = props;
  const { locale } = useConfig();

  const { breakpoints, palette, spacing } = useTheme();
  const itn = priceItinerary;

  const isMobile = useMediaQuery(breakpoints.down("md"));

  return (
    <Box
      sx={{
        height: `${height}%`,
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        top: `${(itn.returnDateDifference + 2) * height}%`,
        bgcolor: palette.grey[100],
        ...sxProps,
        width: spacing(width),
      }}
    >
      {isMobile ? (
        <Box sx={{ justifyContent: "center", display: "flex" }}>
          <Typography
            variant="titleExtraSmall"
            sx={{
              textOrientation: "mixed",
              writingMode: "vertical-lr",
            }}
          >
            {dateObjToDayDateStringShort(new Date(itn.returnDate), locale)}
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography variant="titleMedium" weight="bold">
            {dateObjToMonthShortDate(new Date(itn.returnDate), locale)}
          </Typography>
          <Typography variant="titleExtraSmall">
            {dateObjToWeekday(new Date(itn.returnDate), locale)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
